import { render, staticRenderFns } from "./ModalAyuda.vue?vue&type=template&id=b8737394&"
import script from "./ModalAyuda.vue?vue&type=script&lang=js&"
export * from "./ModalAyuda.vue?vue&type=script&lang=js&"
import style0 from "./ModalAyuda.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports